var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"fst-CopyToClipboard",attrs:{"title":_vm.$t('copyToClipboard.title')}},[(_vm.beforeText)?_c('div',{staticClass:"mb-3",domProps:{"innerHTML":_vm._s(_vm.beforeText)}}):_vm._e(),_c('div',{staticClass:"text-copy",domProps:{"innerHTML":_vm._s(_vm.text)},on:{"click":_vm.handleCopy}})])
}
var staticRenderFns = []

export { render, staticRenderFns }